import { Button } from "@remo-co/ui-core/src/components/Button";
import { useI18n } from "i18n";
import { Link } from "react-router-dom";

interface Props {
  size?: "md" | "sm" | "lg" | "xs";
  className?: string;
  contentClassName?: string;
}

const UpgradePlanButton = ({ size, ...props }: Props) => {
  const { t } = useI18n(["settings"]);

  return (
    <Button<typeof Link>
      variant="primary"
      color="blue"
      size={size ?? "md"}
      data-testid="upgrade-plan-btn"
      component={Link}
      to="/account-settings/billing"
      {...props}
    >
      {t("settings:plan.upgrade")}
    </Button>
  );
};

export default UpgradePlanButton;
